import React from "react";
import Slider from "react-slick";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../../../assets/images/index";
import SampleNextArrow from "./SampleNextArrow";
import SamplePrevArrow from "./SamplePrevArrow";

const NewArrivals = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

const tourDescription = `🕒 Tour Timing & Pickup
• This Old Delhi Tour can be performed any time of the day either in the morning or evening.
• Pickup from the hotel and proceed to Sunehri Masjid (Golden Mosque) near Red Fort parking.

📍 Step 1: Red Fort (Photo Stop)
• Walk to Red Fort to witness the beauty of this massive and historic fort of Delhi.

🕌 Step 2: Jama Masjid Visit
• Take a man-paddling rickshaw to drive to the historical Jama Mosque, constructed under Emperor Shah Jahan.

🛍️ Step 3: Old Delhi Bazaars Exploration
• Walk to capture authentic photos and experience:
  - Kinari Bazaar (Wedding Street)
  - Dariba Kalan (Jewellery Market)
  - Paranthe Wali Gali (Indian Eatery Street)

☕ Step 4: Chai Break
• Take the rickshaw again and drive to taste world-famous masala chai in a kulhad (clay pot).

🌶️ Step 5: Spice Market Experience
• Drive to Asia's best spice market to experience Indian spices.

🚗 Step 6: Return
• Drive back to the parking area and return to the hotel by car.`;

  return (
    <div className="w-full pb-16">
      <Heading heading="New Arrivals" />
      <Slider {...settings}>
        <div className="px-2">
          <Product
            _id="100001"
            img={newArrOne}
            productName="India Tour Guide"
            price="Inquire"
            color="Delhi , India"
            badge={true}
            des={tourDescription}
          />
        </div>
        <div className="px-2">
          <Product
            _id="100002"
            img={newArrTwo}
            productName="Red Fort Tour Guide"
            price="Inquire"
            color="Delhi , India"
            badge={true}
            des={tourDescription}
          />
        </div>
        <div className="px-2">
          <Product
            _id="100003"
            img={newArrThree}
            productName="Old Delhi Tour Guide"
            price="Inquire"
            color="Delhi , India"
            badge={true}
            des={tourDescription}
          />
        </div>
        <div className="px-2">
          <Product
            _id="100004"
            img={newArrFour}
            productName="Delhi Tour Guide"
            price="Inquire"
            color="Delhi , India"
            badge={false}
            des={tourDescription}
          />
        </div>
        <div className="px-2">
          <Product
            _id="100005"
            img={newArrTwo}
            productName="Delhi Red Fort Tour Guide"
            price="Inquire"
            color="Delhi , India"
            badge={false}
            des={tourDescription}
          />
        </div>
      </Slider>
    </div>
  );
};

export default NewArrivals;
